import { Combo, StringHelper } from "@bryntum/schedulerpro";
import TaskEditorColorMapping from "../../../other/constants/TaskEditorColors.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";

export default class SwivuColorField extends Combo {
  static get $name() {
    return "SwivuColorField";
  }

  static get type() {
    return WIDGET_KEYS.colorField;
  }

  static get fields() {
    return [
      { name: "isEventColor", persist: false },
      { name: "canDisplayColorIcon", type: "boolean", defaultValue: false, persist: false },
      { name: "canRemoveColor", type: "boolean", defaultValue: false, persist: false }
    ];
  }

  static get configurable() {
    return {
      editable: false,
      cls: "b-swivucolorfield",
      picker: {
        cls: {
          colorpicker: 1,
          "hidden-scrollbar": 2,
        },
      },
      listItemTpl: (item) => {
        if(Array.isArray(item.value)) {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background: linear-gradient(${item.value.join(', ')})"></div>`;
        }
        if (item?.value?.split("")?.[item?.value?.length - 1] === "x") {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background-color: transparent; box-shadow: none; user-select: none; pointer-events: none;"></div>`;
        } else if (!item.value) {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" >
            <i class="fa-regular fa-eraser"></i>
            Remove color
          </div>`
        }
        else {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background-color: ${item.value}"></div>`;
        }
      },
      items: TaskEditorColorMapping.map((item) => [
        item?.color,
      ]),
      listeners: {
        paint: 'onPaint'
      }
    }
  }

  onPaint({ firstPaint }) {
    if (firstPaint) {
      // Handle store modifications on first paint
      if (this.store) {
        if (this.canRemoveColor && !this.store.findRecord("value", "", true)) {
          this.store.add({
            text: "",
            value: ""
          });
          // Add class to picker when it's available
          if (this.picker?.element) {
            this.picker.element.classList.add("can-remove-color");
          }
        }
        if (this.isEventColor && !this.store.findByField("text", "mixed").length) {
          this.store.insert(0, {
            value: ['red', 'pink', 'purple', 'indigo', 'blue', 'cyan', 'teal', 'green', 'yellow', 'orange'],
            text: 'mixed',
          });
        }
      }

      // Add color bar element to the DOM
      this.addColorBar();
    }
  }

  addColorBar() {
    // Find the input's parent wrapper
    const inputWrap = this.element.querySelector('.b-field-inner') ||
                      this.element.querySelector('.b-combo-input-wrap') ||
                      this.element.querySelector('.b-input-wrap');

    if (!inputWrap) {
      console.warn("SwivuColorField: Could not find input wrapper to add color bar");
      return;
    }

    // Check if color bar already exists
    if (this.element.querySelector('.color-bar')) {
      return;
    }

    // Create and add color bar element
    const colorBar = document.createElement('div');
    colorBar.className = this.canDisplayColorIcon
      ? "color-bar fa-light fa-palette flex items-center !left-5"
      : "color-bar";
    if (this.canDisplayColorIcon) {
      colorBar.style.color = this.value || "";
    } else {
      colorBar.style.backgroundColor = this.value || "transparent";
      colorBar.style.width = "calc(100% - 60px)";
    }

    inputWrap.appendChild(colorBar);
  }

  onChange({ value, source }) {
    super.onChange?.();
    if (this.isEventColor) source.input.style.color = 'transparent'
    // When value is changed, look up for the color bar element and set background color on it
    const colorBarEl = this.element.querySelector(".color-bar");

    if (colorBarEl) {
      if (this.canDisplayColorIcon) {
        colorBarEl.style.color = value;
      } else {
        colorBarEl.style.backgroundColor = value || 'transparent';
      }
      if (this.isEventColor && Array.isArray(value)) {
        colorBarEl.style.backgroundColor = 'transparent';
        source.input.style.color = 'inherit';
        source.input.style.textTransform = 'capitalize';
      }
    }
  }
}

SwivuColorField.initClass();
